import type { DatePresetKey } from "#app/lib/utils/date-presets";
import { parseWidgetFilters } from "#app/widgets/dashboards/widget-filters";
import { useEffectiveScope } from "./scope-shared";
import { windowEmptyTitle, windowPhrase } from "./window-copy";

/**
 * The preset the widget's rows were actually fetched on. Pass the widget's own
 * filter blob (`config.filters`) where it declares one: a widget-owned date
 * range beats the dashboard's, and copy has to report the window the rows came
 * from, not the one the toolbar shows.
 */
function useWindowKey(filters?: unknown): DatePresetKey {
  const { dateRange } = parseWidgetFilters(filters);
  const { effDateRange } = useEffectiveScope(dateRange ? { dateRange } : undefined);
  return effDateRange.key;
}

/**
 * The empty-state line, NAMING the window the widget queried. "No projects in
 * range" tells a reader nothing they can act on — the window lives in a control
 * they have to find first. "No projects this week" names it, so the date
 * control becomes the obvious thing to reach for, and no advice line is needed
 * under it.
 */
export function useWindowEmptyTitle(subject: string, filters?: unknown): string {
  const key = useWindowKey(filters);
  return windowEmptyTitle(subject, key);
}

/**
 * The window as a trailing phrase for copy that is not an empty state — "1,204
 * stage moves this week". `all-time` returns null: the count covers everything,
 * so it takes no qualifier.
 */
export function useWindowPhrase(filters?: unknown): string | null {
  const key = useWindowKey(filters);
  return windowPhrase(key);
}
